import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  EditedRecord,
  PendingTimeOffRequest,
  RequestTypes,
  TimeOffRecord
} from '../../../../models/TimeOffModels';

@Component({
  selector: 'lib-open-request-table',
  templateUrl: './open-request-table.component.html',
  styleUrls: ['./open-request-table.component.css'],
  standalone: false
})
export class OpenRequestTableComponent {
  @Input()
  public requests: PendingTimeOffRequest[] = [];
  @Input()
  public deleted: TimeOffRecord[] = [];
  @Input()
  public edited: EditedRecord[] = [];
  @Input()
  public header: string = '';

  @Output()
  public showCalendar = new EventEmitter<any>();

  @Output()
  public reviewRequest = new EventEmitter<PendingTimeOffRequest>();
  @Output()
  public reviewDeclinedRequest = new EventEmitter<TimeOffRecord>();
  @Output()
  public reviewEditedRequest = new EventEmitter<EditedRecord>();

  protected readonly RequestTypes = RequestTypes;
}
